var _defs, _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappyTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540 440",
    width: 540,
    height: 440,
    role: "img",
    "aria-label": "Happy team celebrating together in the office",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wall",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ede5fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfe8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a9d4ff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 440,
    fill: "url(#wall)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 360,
    width: 540,
    height: 80,
    fill: "#e4dbf5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 48,
    width: 150,
    height: 124,
    rx: 10,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 58,
    width: 130,
    height: 104,
    rx: 6,
    fill: "url(#sky)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 80,
    r: 14,
    fill: "#ffd166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 100 q14 -10 28 0 q14 10 28 0",
    stroke: "#ffffff",
    strokeWidth: 5,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 128 q14 -10 28 0 q14 10 28 0",
    stroke: "#ffffff",
    strokeWidth: 5,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 58,
    width: 6,
    height: 104,
    fill: "#ffffff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 90,
    r: 26,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 90,
    r: 20,
    fill: "#f1eafb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 90 L452 78 M452 90 L461 95",
    stroke: "#6a2dec",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 52,
    width: 64,
    height: 46,
    rx: 14,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258 98 l8 12 l6 -12 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 66 c-4 -6 -14 -4 -14 4 c0 7 9 12 14 16 c5 -4 14 -9 14 -16 c0 -8 -10 -10 -14 -4 z",
    fill: "#9c2ede"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72 300 q-20 -34 -4 -60 q10 22 12 52 z",
    fill: "#3d9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 300 q0 -44 22 -62 q2 30 -12 62 z",
    fill: "#4caf7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 302 q-32 -18 -34 -46 q26 8 38 42 z",
    fill: "#4caf7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 300 h48 l-6 60 h-36 z",
    fill: "#d9c7f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 296,
    width: 56,
    height: 12,
    rx: 6,
    fill: "#c6aef0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 252,
    width: 280,
    height: 14,
    rx: 7,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 266,
    width: 256,
    height: 72,
    fill: "#e0d4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 338,
    width: 14,
    height: 26,
    fill: "#b9a7e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 338,
    width: 14,
    height: 26,
    fill: "#b9a7e6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 196,
    r: 25,
    fill: "#1f1f2e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 200,
    r: 22,
    fill: "#8d5524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 190 q6 -18 30 -14 q10 2 12 12 q-14 -8 -24 -6 q-12 2 -18 8 z",
    fill: "#1f1f2e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 199,
    r: 2.6,
    fill: "#1f1f2e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 199,
    r: 2.6,
    fill: "#1f1f2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 208 q7 7 15 0",
    stroke: "#1f1f2e",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 252 q4 -24 26 -24 q22 0 26 24 z",
    fill: "#6a2dec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 236 Q248 200 262 172",
    stroke: "#6a2dec",
    strokeWidth: 12,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 168,
    r: 8,
    fill: "#8d5524"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 192,
    r: 25,
    fill: "#5b3a29"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 197,
    r: 22,
    fill: "#f1c27d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 172,
    r: 10,
    fill: "#5b3a29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 190 q4 -16 24 -16 q6 0 10 3 q-20 1 -28 16 z",
    fill: "#5b3a29"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 196,
    r: 2.6,
    fill: "#3c2415"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341,
    cy: 196,
    r: 2.6,
    fill: "#3c2415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 205 q7 7 15 0",
    stroke: "#3c2415",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 252 q4 -24 26 -24 q22 0 26 24 z",
    fill: "#ff9f43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 234 Q292 202 276 174",
    stroke: "#ff9f43",
    strokeWidth: 12,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 170,
    r: 8,
    fill: "#f1c27d"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269 148 l4 10 l10 4 l-10 4 l-4 10 l-4 -10 l-10 -4 l10 -4 z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 146,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 150,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 128,
    r: 3.6
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186 252 l10 -22 h34 l-8 22 z",
    fill: "#4a3f66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 250,
    width: 52,
    height: 5,
    rx: 2.5,
    fill: "#6c5f8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 252 l-10 -22 h-34 l8 22 z",
    fill: "#4a3f66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 250,
    width: 52,
    height: 5,
    rx: 2.5,
    fill: "#6c5f8d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 242,
    width: 30,
    height: 10,
    rx: 4,
    fill: "#ffffff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 462,
    cy: 176,
    r: 24,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462,
    cy: 181,
    r: 21,
    fill: "#c68642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 174 q6 -18 30 -13 q8 2 10 10 q-16 -7 -25 -5 q-10 2 -15 8 z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 181,
    r: 2.6,
    fill: "#1f1f2e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 181,
    r: 2.6,
    fill: "#1f1f2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 190 q6 7 14 0",
    stroke: "#1f1f2e",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436 292 q0 -50 26 -50 q26 0 26 50 z",
    fill: "#9c2ede"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 252 Q424 220 428 196",
    stroke: "#9c2ede",
    strokeWidth: 12,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428,
    cy: 190,
    r: 8,
    fill: "#c68642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 252 Q496 246 500 232",
    stroke: "#9c2ede",
    strokeWidth: 12,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 492,
    y: 212,
    width: 20,
    height: 22,
    rx: 4,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 218 q10 2 0 12",
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 206 q2 -5 0 -8 M505 206 q2 -5 0 -8",
    stroke: "#c6aef0",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 292,
    width: 13,
    height: 62,
    rx: 6,
    fill: "#3a2d5c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 292,
    width: 13,
    height: 62,
    rx: 6,
    fill: "#3a2d5c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 350,
    width: 22,
    height: 10,
    rx: 5,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461,
    y: 350,
    width: 22,
    height: 10,
    rx: 5,
    fill: "#222222"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 120,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#9c2ede",
    transform: "rotate(20 134 124)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 112,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#6a2dec",
    transform: "rotate(-15 334 116)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 150,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#ffd166",
    transform: "rotate(30 396 154)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 128,
    r: 4,
    fill: "#ff9f43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505,
    cy: 130,
    r: 4,
    fill: "#6a2dec"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 220,
    r: 4,
    fill: "#9c2ede"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyTeam);
export default __webpack_public_path__ + "static/media/happy-team.da9b2ba7c81adfd7eacd25c9a12feebd.svg";
export { ForwardRef as ReactComponent };